import React, { useEffect, useState } from "react";
import { Col } from 'reactstrap';
import AddComments from './components/addcomments'
import Line from "./components/lineComments";
import Axios from 'axios';
import { Services } from '../../../Services'

function Comments(props) {

	const [comments, setComments] = useState([])


	const Comments = React.useCallback(async () => {
		try {

			const url = `${Services.Getcomments.path}Comments/getcomments/${props.idContainer}`
			const dataComments = await Axios.get(url)
			setComments(dataComments.data.data)
		} catch (error) {
			console.log('The Error-->', error);
		}
	}, [props])

	useEffect(() => {
		Comments()
	}, [Comments])


	return (
		<div>
			<Col xs={12}>
				{/* <CardBody> */}
				<AddComments idContainer={props.idContainer} _user={props._user} getComments={Comments} />
				<Line comments={comments}></Line>
			</Col>
		</div>
	);
}

export default Comments;